import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "mt-4 row" };
const _hoisted_2 = { class: "col-xs-12 col-md-5 p-0 m-0" };
const _hoisted_3 = { class: "col-12 col-md-3 p-0 m-0" };
const _hoisted_4 = { class: "col-12 col-md-4 p-0 m-0" };
const _hoisted_5 = {
    key: 0,
    class: "mt-5 w-100"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_base_input = _resolveComponent("base-input");
    const _component_locations_by_browser_location = _resolveComponent("locations-by-browser-location");
    const _component_search_location_card = _resolveComponent("search-location-card");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _cache[2] || (_cache[2] = _createElementVNode("h2", null, "Finde den nächsten teilnehmenden Markt", -1)),
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_base_input, {
                    label: "Deine Postleitzahl",
                    maxlength: "5",
                    rules: _ctx.rule,
                    name: "zipcode",
                    modelValue: _ctx.searchString,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.searchString) = $event))
                }, null, 8, ["rules", "modelValue"])
            ]),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("button", {
                    class: "[ js-zipcode-search ] buttonBase w-100 mb-2 rounded-right",
                    style: _normalizeStyle(`background-color: ${_ctx.baseColor}; height: 58px; color: white;`),
                    onClick: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.zipSearch && _ctx.zipSearch(...args)))
                }, " Postleitzahlsuche ", 4)
            ]),
            _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_locations_by_browser_location, {
                    style: _normalizeStyle(`background-color: ${_ctx.baseColor}; height: 58px; color: white;`),
                    "region-id": _ctx.restrictedToRegion,
                    "max-results": 3
                }, null, 8, ["style", "region-id"])
            ])
        ]),
        (_ctx.locations)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (location) => {
                    return (_openBlock(), _createBlock(_component_search_location_card, {
                        location: location,
                        key: `location-card-${location.id}`
                    }, null, 8, ["location"]));
                }), 128))
            ]))
            : _createCommentVNode("", true)
    ], 64));
}
